import { reactive } from 'vue';

// Phase-A1 (2026-08-04) — same plain-reactive-object convention as
// notificationStore.js (not a Pinia store; this is transient runtime state
// tied to the current page load, not something that belongs in
// localStorage-persisted state). registerServiceWorker.js owns the actual
// workbox-window instance and injects the real apply-update callback via
// setUpdateAvailable; this store stays ignorant of workbox-window entirely
// so UpdatePrompt.vue can import it without pulling in SW registration
// machinery (and so it's trivially mockable in tests).
const state = reactive({
  updateAvailable: false,
  // Phase 2 (2026-08-26). Set on click, never cleared here.
  //
  // There is deliberately NO clearUpdateAvailable(). Clearing on click would
  // dismiss the pill while leaving the user on the old bundle with no signal
  // that anything is outstanding — strictly worse than a stuck pill, which at
  // least shows something is unresolved. The pill is dismissed by the page
  // reloading, which resets this whole module (it is plain reactive state, not
  // persisted), so a successful update needs no clear and a failed one keeps
  // showing.
  applying: false,
});

let applyUpdateImpl = () => {};

const setUpdateAvailable = (applyFn) => {
  applyUpdateImpl = applyFn;
  state.updateAvailable = true;
};

// Only ever called from the user's own click on the reload prompt — never
// automatically. See service-worker.js's "UPDATE FLOW" comment for the full
// skipWaiting/clients.claim choreography this triggers.
//
// Re-entrant clicks are inert: the update is already in flight, and posting
// SKIP_WAITING again or arming a second reload timeout would only add races.
// registerServiceWorker.js guards its own side too (updateClicked /
// reloadFired) — these are two different concerns, UI state here and reload
// intent there, not one guard duplicated.
const applyUpdate = () => {
  if (state.applying) return;
  state.applying = true;
  applyUpdateImpl();
};

export default {
  state,
  setUpdateAvailable,
  applyUpdate,
};
